import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { last, partial, truncate } from 'lodash';
import useComponentSize from '@rehooks/component-size';
import $ from 'jquery';
import { Nav, Tree } from '.';
import removeHtml from '../../util/remove_html_markup';

const SEARCH_BREAK_POINT = 180;
const MENU_HEIGHT_BREAK_POINT = 112; // old 82
const VIEWPORT_HEIGHT_BREAK_POINT = 210;

function getViewportHeight() {
  const { innerHeight: height } = window;
  return height;
}

export default function Header({
  logo = '',
  logoLink = '',
  linkPrefix,
  backgroundColor = 'rgba(255,255,255,0)',
  backgroundImage = '',
  navTextColor,
  navPosition = 'none',
  isInnerHeader = false,
  backgroundPosition = 'center',
  position = '',
  navs,
  googleTranslate = false,
  corporationName,
}) {
  const navRef = useRef(null);
  const navHorizontalRef = useRef(null);
  const toggleButtonRef = useRef(null);
  const headerRef = useRef(null);
  const searchContainerRef = useRef(null);
  const searchFieldRef = useRef(null);
  const translatorRef = useRef(null);
  let headerHeightDynamicValue = 999999;
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchVisible, setSearchVisibility] = useState(false);
  const [isMenuVisible, setMenuVisibility] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const { width: searchContainerWidth } = useComponentSize(searchContainerRef);
  const { height: headerHeight, width: headerWidth } = useComponentSize(headerRef);
  const [viewportHeight, setViewportHeight] = useState(getViewportHeight());

  useLayoutEffect(() => {
    $(searchContainerRef.current).addClass('env-search-observable-js--hidden');
  });
  useEffect(() => {
    if (translatorRef.current && !window.googleTranslateElementInit) {
      window.$ = $;
      window.jQuery = $;
      window.googleTranslateElementInit = () => {
        new google.translate.TranslateElement(
          {
            // eslint-disable-line
            pageLanguage: 'en',
            includedLanguages: 'es,zh-CN,tl,vi,ar,fr,ko,ru,de,ht,hi,pt,it,pl,yi,ja,fa,gu,te,bn,th,so',
            layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          'google_translate_element',
        );
      };

      $('google_translate_element').html('');
      $.getScript('https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
    }
  }, [translatorRef.current]);
  useEffect(() => {
    const $toggleMenuButton = $(toggleButtonRef.current);
    const $navDropdownGroup = $('.env-dropdown-group__content');

    if (navPosition === 'top') {
      const $nav = $(navHorizontalRef.current);
      let navHeight = 0;

      $nav.removeClass('nav-menu-horizontal-hidden').find('.nav-menu-horizontal').addClass('nav-menu-horizontal-show');
      $toggleMenuButton.hide();
      $navDropdownGroup.hide();

      navHeight = $nav.height();

      if (navHeight >= headerHeightDynamicValue || viewportHeight < VIEWPORT_HEIGHT_BREAK_POINT) {
        $toggleMenuButton.show();
        $nav.addClass('nav-menu-horizontal-hidden').find('.nav-menu-horizontal').removeClass('nav-menu-horizontal-show');
        $navDropdownGroup.show();
      }
    }

    if (navPosition === 'left') {
      $toggleMenuButton.show();
    }
  }, [
    logo,
    navs,
    navPosition,
    isInnerHeader,
    headerWidth,
    headerHeight,
    headerHeightDynamicValue,
    isMenuVisible,
    position,
    viewportHeight,
  ]);

  useEffect(() => {
    function handleResize() {
      setViewportHeight(getViewportHeight());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const searchList = [];

  navs.forEach(
    ({
      id,
      title,
      measures,
      items,
      latestUpdate,
      additionalBottomText,
      additionalMiddleText,
      additionalUpperMiddleText,
      additionalText,
      description,
      customFields,
      tags,
    }) => {
      searchList.push({
        id,
        isMeasure: false,
        title,
        latestUpdate,
        additionalBottomText,
        additionalMiddleText,
        additionalUpperMiddleText,
        additionalText,
        description,
        customFields,
        tags,
      });
      measures.forEach(
        ({
          id: measureId,
          title: measureTitle,
          latestUpdate,
          additionalBottomText,
          additionalMiddleText,
          additionalUpperMiddleText,
          additionalText,
          description,
          customFields,
          tags,
        }) => {
          searchList.push({
            id: measureId,
            isMeasure: true,
            title: measureTitle,
            latestUpdate,
            additionalBottomText,
            additionalMiddleText,
            additionalUpperMiddleText,
            additionalText,
            description,
            customFields,
            tags,
          });
        },
      );
      items.forEach(
        ({
          id: strategyId,
          title: strategyTitle,
          measures: strategyMeasures,
          items: activities,
          latestUpdate,
          additionalBottomText,
          additionalMiddleText,
          additionalUpperMiddleText,
          additionalText,
          description,
          customFields,
          tags,
        }) => {
          searchList.push({
            id: strategyId,
            isMeasure: false,
            title: strategyTitle,
            latestUpdate,
            additionalBottomText,
            additionalMiddleText,
            additionalUpperMiddleText,
            additionalText,
            description,
            customFields,
            tags,
          });
          strategyMeasures.forEach(
            ({
              id: measureId,
              title: measureTitle,
              latestUpdate,
              additionalBottomText,
              additionalMiddleText,
              additionalUpperMiddleText,
              additionalText,
              description,
              customFields,
              tags,
            }) => {
              searchList.push({
                id: measureId,
                isMeasure: true,
                title: measureTitle,
                latestUpdate,
                additionalBottomText,
                additionalMiddleText,
                additionalUpperMiddleText,
                additionalText,
                description,
                customFields,
                tags,
              });
            },
          );
          activities.forEach(
            ({
              id: activityId,
              title: activityTitle,
              measures: activityMeasures,
              latestUpdate,
              additionalBottomText,
              additionalMiddleText,
              additionalUpperMiddleText,
              additionalText,
              description,
              customFields,
              tags,
            }) => {
              searchList.push({
                id: activityId,
                isMeasure: false,
                title: activityTitle,
                latestUpdate,
                additionalBottomText,
                additionalMiddleText,
                additionalUpperMiddleText,
                additionalText,
                description,
                customFields,
                tags,
              });
              activityMeasures.forEach(
                ({
                  id: measureId,
                  title: measureTitle,
                  latestUpdate,
                  additionalBottomText,
                  additionalMiddleText,
                  additionalUpperMiddleText,
                  additionalText,
                  description,
                  customFields,
                  tags,
                }) => {
                  searchList.push({
                    id: measureId,
                    isMeasure: true,
                    title: measureTitle,
                    latestUpdate,
                    additionalBottomText,
                    additionalMiddleText,
                    additionalUpperMiddleText,
                    additionalText,
                    description,
                    customFields,
                    tags,
                  });
                },
              );
            },
          );
        },
      );
    },
  );

  const onSearch = ({ target: { value } }) => {
    setSearchTerm(value || '');

    if (value.length) {
      setSearchResults(
        searchList.filter(
          ({
            title,
            latestUpdate,
            additionalBottomText,
            additionalMiddleText,
            additionalUpperMiddleText,
            additionalText,
            description,
            customFields,
            tags,
          }) =>
            title.toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(latestUpdate).toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(additionalBottomText).toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(additionalMiddleText).toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(additionalUpperMiddleText).toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(additionalText).toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(tags).toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(customFields).toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            removeHtml(description).toLowerCase().indexOf(value.toLowerCase()) >= 0,
        ),
      );
    } else {
      setSearchResults([]);
    }

    setMenuVisibility(false);
  };
  const toggleSearchVisibility = ({ currentVisibility }) => {
    setMenuVisibility(false);
    setSearchVisibility(!currentVisibility);
  };
  const toggleMenuVisibility = ({ currentVisibility }) => {
    setSearchVisibility(false);
    setMenuVisibility(!currentVisibility);
    setSearchResults([]);

    searchFieldRef.current.value = '';
  };

  // if (headerHeight && headerHeight < 300) { // @Barry, Why we have this before @Eugene commented ?
  headerHeightDynamicValue = MENU_HEIGHT_BREAK_POINT;
  // }

  const logoImg = logoLink ? (
    <a
      className="logo-header-link"
      href={logoLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={corporationName}
      title={corporationName}
      id="lnkLogo"
    >
      <img className="logo-header" src={logo} alt={corporationName} />
    </a>
  ) : (
    <Link className="logo-header-link" to={linkPrefix || ''} aria-label={corporationName} title={corporationName} id="lnkLogo">
      <img className="logo-header" src={logo} alt={corporationName} />
    </Link>
  );
  const searchPageContainer = (
    <div className="search-page-container env-dropdown-group__special">
      <div className="search-field-container">
        <FontAwesomeIcon icon={['fal', 'search']} />
        <label htmlFor="txtSearch">
          <span className="search-title">Search</span>
          <input
            type="search"
            name="txtSearch"
            id="txtSearch"
            className="form-control"
            placeholder="Search"
            aria-label="Search"
            onChange={onSearch}
            ref={searchFieldRef}
          />
        </label>
      </div>
      {!!searchResults.length && (
        <div aria-live="assertive" role="alert">
          <ul className="search-result-container">
            {searchResults.map(
              ({
                title,
                id,
                latestUpdate,
                additionalBottomText,
                additionalMiddleText,
                additionalUpperMiddleText,
                additionalText,
                description,
                customFields,
                tags,
              }) => {
                const keyword = searchTerm.toLowerCase();
                const descriptionText = removeHtml(description || '');
                const updateText = removeHtml(latestUpdate || '');
                const topText = removeHtml(additionalText || '');
                const middleText = removeHtml(additionalMiddleText || '');
                const upperMiddleText = removeHtml(additionalUpperMiddleText || '');
                const bottomText = removeHtml(additionalBottomText || '');
                const customFieldText = removeHtml(customFields || '');
                const descriptionIndex = descriptionText.toLowerCase().indexOf(keyword);
                const updateIndex = updateText.toLowerCase().indexOf(keyword);
                const topIndex = topText.toLowerCase().indexOf(keyword);
                const middleIndex = middleText.toLowerCase().indexOf(keyword);
                const upperMiddleIndex = upperMiddleText.toLowerCase().indexOf(keyword);

                const bottomIndex = bottomText.toLowerCase().indexOf(keyword);
                const tagIndex = tags.toLowerCase().indexOf(keyword);
                const customFieldIndex = customFieldText.toLowerCase().indexOf(keyword);
                let text = '';

                switch (true) {
                  case descriptionIndex >= 0:
                    text = truncate(
                      `${last(descriptionText.slice(0, descriptionIndex).split(' '))}${descriptionText.slice(descriptionIndex)}`,
                      { separator: ' ', length: 60 },
                    );

                    break;
                  case updateIndex >= 0:
                    text = truncate(`${last(updateText.slice(0, updateIndex).split(' '))}${updateText.slice(updateIndex)}`, {
                      separator: ' ',
                      length: 60,
                    });

                    break;
                  case topIndex >= 0:
                    text = truncate(`${last(topText.slice(0, topIndex).split(' '))}${topText.slice(topIndex)}`, {
                      separator: ' ',
                      length: 60,
                    });

                    break;
                  case middleIndex >= 0:
                    text = truncate(`${last(middleText.slice(0, middleIndex).split(' '))}${middleText.slice(middleIndex)}`, {
                      separator: ' ',
                      length: 60,
                    });

                    break;
                  case upperMiddleIndex >= 0:
                    text = truncate(
                      `${last(upperMiddleText.slice(0, upperMiddleIndex).split(' '))}${upperMiddleText.slice(upperMiddleIndex)}`,
                      {
                        separator: ' ',
                        length: 60,
                      },
                    );

                    break;
                  case bottomIndex >= 0:
                    text = truncate(`${last(bottomText.slice(0, bottomIndex).split(' '))}${bottomText.slice(bottomIndex)}`, {
                      separator: ' ',
                      length: 60,
                    });

                    break;
                  case tagIndex >= 0:
                    text = truncate(`${last(tags.slice(0, tagIndex).split(' '))}${tags.slice(tagIndex)}`, {
                      separator: ' ',
                      length: 60,
                    });

                    break;
                  case customFieldIndex >= 0:
                    text = truncate(
                      `${last(customFieldText.slice(0, customFieldIndex).split(' '))}${customFieldText.slice(customFieldIndex)}`,
                      { separator: ' ', length: 60 },
                    );

                    break;
                  default:
                    break;
                }

                return (
                  <li key={['search', 'list', 'item', id].join('-')}>
                    <Link to={`${linkPrefix}/${id}`}>
                      <strong>{title}</strong>
                      {!!text && (
                        <p tabIndex={-1} aria-hidden={true}>
                          {text}
                        </p>
                      )}
                    </Link>
                  </li>
                );
              },
            )}
          </ul>
        </div>
      )}
    </div>
  );
  const headerStyle = isInnerHeader ? {} : { backgroundColor, backgroundImage: `url(${backgroundImage})`, backgroundPosition };

  return (
    <header
      className={`header env-dropdown-group${isInnerHeader ? ' header-inner' : ''} ${
        isInnerHeader && position === 'top' ? 'header-top-inner' : ''
      }`}
      ref={headerRef}
      style={headerStyle}
    >
      <div className="logo-header-wrapper">{logoImg}</div>
      {navPosition !== 'none' && navs.length > 0 && (
        <button
          type="button"
          onClick={partial(toggleMenuVisibility, { currentVisibility: isMenuVisible })}
          className="toggle-menu-btn-top"
          ref={toggleButtonRef}
          aria-label="Menu"
          style={{ color: navTextColor }}
        >
          <FontAwesomeIcon icon={['fal', `${isMenuVisible ? 'times' : 'bars'}`]} style={{ color: navTextColor }} size="lg" />
        </button>
      )}
      {navPosition === 'top' && navs.length > 0 && (
        <Nav
          items={navs}
          linkPrefix={linkPrefix}
          navTextColor={navTextColor}
          ref={navHorizontalRef}
          className="nav-menu-collapse nav-menu-horizontal"
          horizontal
        />
      )}
      {navPosition === 'top' && navs.length > 0 && !!isMenuVisible && (
        <div className="env-dropdown-group__content">
          <Nav
            items={navs}
            linkPrefix={linkPrefix}
            navTextColor={navTextColor}
            ref={navRef}
            className="nav-menu-collapse nav-menu-vertical"
          />
        </div>
      )}
      {navPosition === 'left' && navs.length > 0 && !!isMenuVisible && (
        <div className="env-dropdown-group__content">
          <Tree items={navs} linkPrefix={linkPrefix} className="nav-menu-collapse nav-menu-vertical" />
        </div>
      )}
      {!!googleTranslate && (
        <div
          id="google_translate_element"
          ref={translatorRef}
          className="google-translate-element"
          // style={{
          //   flex: '2 1 auto',
          //   justifyContent: 'flex-end',
          //   display: 'flex',
          //   alignSelf: 'center',
          //   // paddingTop: '17px',
          // }}
        />
      )}
      {!!searchList.length && (
        <div
          className="env-search-observable-js"
          ref={searchContainerRef}
          role="search"
          style={googleTranslate ? { flex: '1 1 50px' } : { marginLeft: 'auto' }}
        >
          {searchContainerWidth > SEARCH_BREAK_POINT ? (
            searchPageContainer
          ) : (
            <>
              <button
                className="env-dropdown-group__button"
                type="button"
                onClick={partial(toggleSearchVisibility, { currentVisibility: isSearchVisible })}
                aria-label="Search"
              >
                <FontAwesomeIcon icon={['fal', 'search']} color={navTextColor} />
              </button>
              {isSearchVisible ? <div className="env-dropdown-group__content">{searchPageContainer}</div> : ''}
            </>
          )}
        </div>
      )}
    </header>
  );
}

Header.propTypes = {
  logo: PropTypes.string,
  logoLink: PropTypes.string,
  linkPrefix: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  navTextColor: PropTypes.string.isRequired,
  navPosition: PropTypes.string.isRequired,
  isInnerHeader: PropTypes.bool,
  backgroundPosition: PropTypes.string,
  position: PropTypes.string,
  navs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      level: PropTypes.number,
      isMeasure: PropTypes.bool,
      items: PropTypes.arrayOf(PropTypes.shape({})),
      measures: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  ).isRequired,
  googleTranslate: PropTypes.bool,
  corporationName: PropTypes.string.isRequired,
};
